import axiosClient from "../../../../system/helpers/axiosConfig";

export const getLandingPageStatuses = () => {
  return axiosClient
    .get("/api/admin/landing-pages/statuses")
    .then((r) => r.data);
};
